import * as React from 'react';
import { Row } from 'react-bootstrap';
import { formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { actions as authActions } from '../../../../services/auth/reducer';
import { IAuthActions, IAuthState } from '../../../../services/auth/models';
import CreateAnAccountForm from './components/CreateAnAccountForm';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { IBrandingState } from '../../../../services/branding/models';

export interface ICreateAnAccountProps {
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  branding: IBrandingState;
}

class CreateAnAccount extends React.Component<ICreateAnAccountProps> {
  public state = {
    loading: false,
  };

  private handleSubmit = (value) => {
    const { actions, branding} = this.props;
    this.setState({ loading: true });
    Promise.resolve(actions.auth.createAccount(
      value.email,
      { channel: branding.channel.key },
      branding.requestItems.httpScheme,
      branding.requestItems.host,
    )).then(() => {
      this.setState({ loading: false });
    });
  }

  public render() {
    const { auth } = this.props;

    return (
      <Row className="page-container">
        <div className="customer-section-title">
          <h1>Create an account</h1>
          <h4>Please provide the information below, in order to create your account</h4>
        </div>
        {!auth.createAccount ? (
          <CreateAnAccountForm onSubmit={this.handleSubmit} loading={this.state.loading}/>
        ) : (
          <div className="blue-section">
            <p>We have emailed you with a link to verify your email address and set your password.</p>
            <p> If you don’t receive the email within five minutes, please check your Junk folder.</p>
            <p>Note: the link in the email will expire in 24 hours.</p>
          </div>
        )}
      </Row>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'create-an-account',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('create-an-account');

    return component;
  },
  connect(
    (state) => {
      return {
        auth: state.auth,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(CreateAnAccount);
